<div
  [ngClass]="{
    'disney-detail':
      isDisney &&
      (errorResponse === null ||
        (errorResponse.error.code !== 4121 && errorResponse.error.code !== 4122)),
    'hotel-detail':
      !isDisney ||
      errorResponse === null ||
      (errorResponse.error.code !== 4121 && errorResponse.error.code !== 4122),
  }"
>
  <search-widget
    *ngIf="!busy"
    [isLanding]="isLanding"
    [searchedEntity]="searchedEntity"
    [section]="'detail'"
    (resetState)="onResetState()"
    [isDisney]="isDisney"
    [isExperts]="isExperts"
  >
  </search-widget>

  <div class="mb-grid-container-full container-detail">
    <div
      [ngClass]="{ 'disney-color': isDisney }"
      class="am-ctn--xxl"
      id="description-container">
      <div
        [ngClass]="{
          'containter-breadcrumb ':
            errorResponse === null ||
            (errorResponse.error.code !== 4121 && errorResponse.error.code !== 4122),
        }"
        class="">
        <div class="mb-grid-container-full mb-grid-row">
          <breadcrumb
            [entity]="hotelStaticInfo?.entity"
            [hotelName]="hotelStaticInfo?.name"
            class="mb-grid-col-8-dt"
          ></breadcrumb>
        </div>
      </div>
      <div
        class="mb-grid-col-12"
        style="padding: 0; position: relative"
        *ngIf="
          errorResponse === null ||
          (errorResponse.error.code !== 4121 && errorResponse.error.code !== 4122)
        "
      >
        <div class="mb-grid-container-full mb-grid-row">
          <div class="mb-grid-col-8-dt ctn-detail-bkg">
            <header-detail
              [bestAvailable]="bestAvailable"
              [busy]="busy"
              [isLanding]="isLanding"
              [isDisney]="isDisney"
              [priceByValue]="priceByValue"
              [actualContainer]="actualContainer"
              [scrollMenu]="scrollMenu"
              [disableMenuReviews]="
                isCvc || !hotelAvailabilityInfo?.rating_summary?.rating
              "
              [disableMenuRelated]="
                !hotelAvailabilityInfo || recommendedHotels?.length === 0
              "
              [error]="!!hotelAvailabilityInfo?.error"
              (handleClickMenuOption)="handleClickMenuOption($event)"
              class="mb-grid-container-full"
            ></header-detail>

            <div class="mb-grid-container-full container-component">
              <div class="mb-col-12" style="padding: 0">
                <!-- descripcion container -->
                <div class="am-ctn mb-container-full description-container">
                  <div
                    class="mb-container-full info-container ctn-info-detail"
                    *ngIf="hasUniversal || isDisney"
                  >
                    <image-message
                      [hotelCountry]="hotelStaticInfo?.country?.id"
                    ></image-message>
                    <universal-benefits-detail
                      *ngIf="hasUniversal"
                      [hotelId]="hotelStaticInfo?.id"
                    ></universal-benefits-detail>
                    <am-disney-benefits
                      *ngIf="isDisney && (brand === 'almundo' || brand === 'avantrip')"
                    ></am-disney-benefits>
                  </div>
                  <ng-container *ngIf="showAvuxi">
     
                    <avuxi
                      type="top_locations"
                      [position]="hotelPosition"
                      action="show"
                      [brand]="brand"
                    ></avuxi>

                  </ng-container>
                  <div class="info-container mb-grid-container-full ctn-info-detail">
                    <div class="mb-grid-container-full flex-colum content-des">
                      <div class="mb-grid-row mb-grid-container-full ctn-description">
                        <amenities
                          *ngIf="hotelStaticInfo?.amenities"
                          [isDisney]="isDisney"
                          [amenities]="hotelStaticInfo?.amenities"
                          class="mb-grid-col-12-dt first-element last-element"
                          id="aminities"
                        ></amenities>
                      </div>

                      <description
                        *ngIf="
                          hotelStaticInfo?.description &&
                          hotelStaticInfo?.description?.hotel_description?.length > 0
                        "
                        [description]="hotelStaticInfo?.description"
                        [hotelStatic]="hotelStaticInfo"
                        [isLanding]="isLanding"
                        [additionalInfos]="hotelStaticInfo?.additional_infos"
                      ></description>

                      <ng-container *ngIf="isDisney">
                        <div
                          class="mb-grid-container-full mb-grid-row pricebox-container aling-elements"
                        >
                          <div class="mb-grid-col-5-dt ctn-description first-element">
                            <activities-information-disney
                              id="activities"
                            ></activities-information-disney>
                          </div>
                          <div class="mb-grid-col-7-dt ctn-description last-element">
                            <parking-disney></parking-disney>
                          </div>
                        </div>
                      </ng-container>
                      <div
                        class="mb-grid-container-full mb-grid-row pricebox-container aling-elements"
                      >
                        <div class="mb-grid-col-5-dt ctn-description first-element">
                          <check-times
                            [staticInfo]="hotelStaticInfo"
                            id="checkTimes"
                          ></check-times>
                        </div>
                        <div class="mb-grid-col-7-dt ctn-description last-element">
                          <cancel-policies
                            id="polices"
                            [isDisney]="isDisney"
                            [countryId]="hotelStaticInfo?.country?.id"
                          ></cancel-policies>
                        </div>
                      </div>
                      <am-comments *ngIf="comments" [comments]="comments"></am-comments>
                    </div>
                  </div>
                </div>

                <!-- fin descripcion -->
              </div>
            </div>
          </div>

          <div class="content-pricebox mb-grid-col-4-dt mb-grid-row">
            <div class="mb-grid-col-12-dt pricebox-container">
              <price-box
                [bestAvailable]="bestAvailable"
                [busy]="busy"
                [isLanding]="isLanding"
                [priceByValue]="priceByValue"
                [showAmountTotal]="hotelAvailabilityInfo?.show_amount_total"
                [isDisney]="isDisney"
              ></price-box>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ng-container
      *ngIf="
        errorResponse === null ||
        (errorResponse.error.code !== 4121 && errorResponse.error.code !== 4122)
      "
    >
      <div
        [ngClass]="{ 'disney-color': isDisney }"
        class="am-ctn--xxl container-component"
        id="rooms-container"
      >
        <div class="mb-grid-container-full">
          <am-filters-container
            *ngIf="!isLanding && !busy && showRoomOptions">
          </am-filters-container>

          <div
            id="rooms"
            *ngIf="!isLanding"
            class="am-ctn--gtr-inside mb-grid-container-full ctn-rooms">
            <div id="pay_at_destination" class="container-rooms">
              <div
                *ngIf="(!hotelAvailabilityInfo && busy) || isLanding"
                class="loader-wrapper">
                <loader-detail></loader-detail>
              </div>
              <room-options
                id="room-options"
                [isHomestay]="isHomestay"
                (paymentMethodSelected)="paymentMethodSelected($event)"
                (handleRefundableRateChange)="handleRefundableRateChange($event)"
                [isDisney]="isDisney"
                [hotelAvailabilityInfo]="hotelAvailabilityInfo"
                [priceByValue]="priceByValue"
                *ngIf="!busy && showRoomOptions"
                [showAmountTotal]="hotelAvailabilityInfo?.show_amount_total"
                [hotelStaticInfo]="hotelStaticInfo"
                [showRefundableRateAlert]="showRefundableRateAlert"
                [showPaymentsOptionsAlert]="showPaymentsOptionsAlert"
                [paymentMethodValue]="selectedPaymentMethod"
                (showMoreRooms)="showMoreRooms()"
                class="am-ctn--gtr-inside rooms"
              ></room-options>
              <accommodation-fee
                *ngIf="accommodationFee && locale === 'pt-BR'"
                [accommodationFee]="accommodationFee"
              ></accommodation-fee>
            </div>
          </div>
        </div>
      </div>
      <div
        *ngIf="
          hotelStaticInfo?.description?.room_fees_description ||
          hotelStaticInfo?.description?.mandatory_fees_description
        "
        class="am-ctn--xxl container-component mb-grid-container-full mb-grid-row"
      >
        <div class="mb-grid-col-12-dt">
          <div class="am-ctn container-services">
            <services
              [services]="hotelStaticInfo?.description"
              class="am-ctn--gtr-inside"
            ></services>
          </div>
        </div>
      </div>
      <div
        *ngIf="!isCvc && hotelAvailabilityInfo?.rating_summary?.rating"
        class="am-ctn--xxl container-component"
        id="reviews-container">
        <div class="mb-grid-container-full mb-grid-row ">
          <div class="mb-grid-col-12-dt mb-grid-row">
            <tripadvisor-reviews
              [data]="hotelStaticInfo"
              class="am-ctn--gtr-inside mb-grid-col-12-dt"
            ></tripadvisor-reviews>
          </div>
        </div>
      </div>
      <div
        *ngIf="(hotelAvailabilityInfo || isLanding) && recommendedHotels?.length > 0"
        class="am-ctn--xxl container-component"
        id="related-container">
        <div class="mb-grid-container-full mb-grid-row">
          <related-hotels
            class="mb-grid-col-12-dt"
            [name]="hotelStaticInfo?.name"
            [related]="recommendedHotels"
            [priceByValue]="priceByValue"
            [showAmountTotal]="hotelAvailabilityInfo?.show_amount_total"
            [section]="'Detail'"
            [isLanding]="isLanding"
            [hotelCountry]="hotelStaticInfo?.country?.id"
            [hotelCity]="hotelStaticInfo?.city?.id"
          ></related-hotels>
        </div>
      </div>
    </ng-container>

    <div
      class="error"
      *ngIf="errorResponse !== null"
      [ngSwitch]="errorResponse.error.code"
    >
      <ng-container *ngSwitchCase="4122">
        <div class="title">
          <p>No tenemos alojamientos nacionales en dólares</p>
        </div>
        <div class="subtitle">
          <p>Probá cambiando el tipo de moneda a $ Pesos Argentinos</p>
        </div>
        <div class="facture">
          <div class="svg-facture"></div>
        </div>
        <div class="actionable-btn-wrapper">
          <button
            mb-button
            variant="outline"
            color="primary"
            (click)="onResetState('ARS')"
          >
            BUSCAR EN $ PESOS
          </button>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="4121">
        <div class="title">
          <p>No tenemos alojamientos nacionales en dólares</p>
        </div>
        <div class="subtitle">
          <p>Proba cambiando el tipo de moneda a $ Pesos Argentinos</p>
        </div>
        <div class="facture">
          <div class="svg-facture"></div>
        </div>
        <div class="actionable-btn-wrapper">
          <button
            mb-button
            variant="outline"
            color="primary"
            (click)="onResetState('ARS')"
          >
            BUSCAR EN $ PESOS
          </button>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="4123">
        <div class="title">
          <p>No tenemos alojamientos en dólares</p>
        </div>
        <div class="subtitle">
          <p>Proba cambiando el tipo de moneda a $ Pesos Argentinos</p>
        </div>
        <div class="facture">
          <div class="svg-facture-no-almundo"></div>
        </div>
      </ng-container>
    </div>
  </div>

</div>
